import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InitializeService {
  private readonly _appComponentInitializing = new BehaviorSubject(true);

  appComponentInitializing$ = this._appComponentInitializing.asObservable();
  appComponentInitializing = this._appComponentInitializing.value;

  setInitialized() {
    this._appComponentInitializing.next(false);
  }
}
